var MarkerIconName;
(function (MarkerIconName) {
    MarkerIconName["CLINICIAN"] = "clinician";
    MarkerIconName["ARRIVAL"] = "arrival";
    MarkerIconName["PLAY"] = "play";
    MarkerIconName["HOME"] = "home";
})(MarkerIconName || (MarkerIconName = {}));

export { MarkerIconName };
